
const DATA_DRIVEN_PORTFOLIOS = `Explain the Benefits of Data-Driven Portfolio Adjustments

Key Points:
- Buy and hold strategy involves investing in a portfolio and holding it for the long term without making frequent adjustments.
- Data-driven adjustments involve using quantitative models and algorithms to continuously analyze market data and make strategic changes to the portfolio.
- Data-driven approaches can help optimize portfolio performance by adapting to changing market conditions and risk factors.
- By leveraging data and technology, data-driven adjustments can potentially enhance risk-adjusted returns and improve long-term outcomes compared to a static buy and hold approach.

Tone: Simple and clear explanation for clients

Output: Generate a concise explanation highlighting the potential benefits of data-driven portfolio adjustments over a buy and hold strategy, emphasizing how it can improve long-term investment outcomes for clients.`


const EQUITY_FIXED_DYNAMIC_RELATIONSHIP = `Explain the Evolving Relationship Between Fixed Income and Equities

Key Points:
- Traditionally, fixed income (bonds) and equities (stocks) have had an inverse relationship, meaning when stock markets are volatile, bonds have often acted as a safe haven.
- This inverse relationship was based on the assumption that bonds provide stability and steady income during market downturns.
- However, in recent years, the relationship between fixed income and equities has become more complex and less predictable.
- Factors such as low interest rates, quantitative easing, and increased market complexity have altered the traditional dynamics.
- In the current environment, certain complex fixed income instruments may carry higher risks than in the past, especially for investors near or in retirement.
- It is important for investors to understand these changes and carefully consider the role of fixed income in their portfolios based on their specific goals and risk tolerance.

Tone: Simple and clear explanation for clients

Output: Generate a concise explanation of the changing relationship between fixed income and equities, highlighting the potential risks of complex fixed income instruments in the current market environment, particularly for investors near or in retirement.`


export const GENERAL_TEMPLATES = {
    dataDrivenPortfolios: {
        prompt: DATA_DRIVEN_PORTFOLIOS,
        title: "Explain Data-Driven Portfolios"
    },
    equityFixedRelationship: {
        prompt: EQUITY_FIXED_DYNAMIC_RELATIONSHIP,
        title: "Explain Relationship Between Fixed Income and Equities"
    }
}



